export var AfriexVerificationStatus;
(function (AfriexVerificationStatus) {
    AfriexVerificationStatus["NotStarted"] = "notStarted";
    AfriexVerificationStatus["Started"] = "started";
    AfriexVerificationStatus["Submitted"] = "submitted";
    AfriexVerificationStatus["Pending"] = "pending";
    AfriexVerificationStatus["Failed"] = "failure";
    AfriexVerificationStatus["Rejected"] = "rejected";
    AfriexVerificationStatus["Success"] = "success";
    AfriexVerificationStatus["ReuploadRequested"] = "reuploadRequested";
    AfriexVerificationStatus["Reuploaded"] = "reuploaded";
})(AfriexVerificationStatus || (AfriexVerificationStatus = {}));
//# sourceMappingURL=AfriexVerificationStatus.js.map